module.exports = __webpack_public_path__ + "img/gun-turret-gun-shadow-1.8552d96a.png";